import React from 'react';
import { LegacyButtonProps } from '@/shared/types/legacyButton';
import { InnerLegacyButton } from './InnerLegacyButton';

/**
 * Botón equivalente a `Button`, pero los slots e iconos usan nombres tipados de `LegacyIcon` (SVG legacy).
 */
export const LegacyButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement | HTMLDivElement,
  LegacyButtonProps
>(function LegacyButton(
  {
    className,
    fullWidth = false,
    leftSlot,
    rightSlot,
    theme = 'solid',
    badgeColor,
    badgeLabel,
    badgeTheme,
    badgeSize,
    badgeStroke,
    badgeIcon,
    badgeIconDuotonePrimary,
    badgeIconDuotoneSecondary,
    badgeIconDuotoneOpacityPrimary,
    badgeIconDuotoneOpacitySecondary,
    clickable = true,
    color = 'primary',
    rounded,
    children,
    icon,
    link,
    size = 'sm',
    target = '_self',
    onClickIcon,
    disabled,
    colorIcon,
    tooltip,
    tooltipPosition,
    tooltipAlignment,
    tooltipDelay,
    ...props
  },
  ref
) {
  return (
    <InnerLegacyButton
      ref={ref}
      theme={theme}
      color={color}
      rounded={rounded}
      fullWidth={fullWidth}
      size={size}
      clickable={clickable}
      children={children}
      icon={icon}
      badgeColor={badgeColor}
      badgeLabel={badgeLabel}
      badgeTheme={badgeTheme}
      badgeSize={badgeSize}
      badgeStroke={badgeStroke}
      badgeIcon={badgeIcon}
      badgeIconDuotonePrimary={badgeIconDuotonePrimary}
      badgeIconDuotoneSecondary={badgeIconDuotoneSecondary}
      badgeIconDuotoneOpacityPrimary={badgeIconDuotoneOpacityPrimary}
      badgeIconDuotoneOpacitySecondary={badgeIconDuotoneOpacitySecondary}
      leftSlot={leftSlot}
      rightSlot={rightSlot}
      link={link}
      target={target}
      onClickIcon={onClickIcon}
      disabled={disabled}
      colorIcon={colorIcon}
      className={className}
      tooltip={tooltip}
      tooltipPosition={tooltipPosition}
      tooltipAlignment={tooltipAlignment}
      tooltipDelay={tooltipDelay}
      {...props}
    />
  );
});

LegacyButton.displayName = 'LegacyButton';
